<template>
  <v-dialog v-model="localModel" max-width="75%">
    <v-card class="text-center pt-2">
      <v-card-text>
        <div>
          <h3>The rules of Pebbles</h3>
          <h5>v{{ version }}</h5>
        </div>
        <div class="text-left my-2">
          Place as many pieces on the board as you can before it is full. Fill a line or a column to make the pieces disappear!
        </div>
        <div class="popup-help__grid">
          <div><img src="screenshot_01.png" width="auto" height="170" /></div>
          <div>1. <b>Drag and drop</b> pieces from the deck to the grid. Whenever you place a piece, you get <i>3 points</i>.</div>
          <div>2. <b>Fill one or more line or column</b> to remove it and score even more points! You get <i>10 points</i> for 1 line or column, <i>40 points</i> for 2, <i>90 points</i> for 3...</div>
          <div><img src="screenshot_02.png" width="auto" height="140" /></div>
          <div><img src="screenshot_03.png" width="auto" height="170" /></div>
          <div>3. If the grid is filled up and you can't place any piece from your deck anymore, then it's <b>game over</b>!</div>
        </div>
        <v-row class="justify-center" no-gutters>
          <v-btn @click="$emit('close')"> close </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import * as pkg from "../../../package.json";

export default {
  name: "PopupHelp",
  props: {
    value: { type: Boolean, required: true }
  },
  computed: {
    localModel: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    },
    version() {
      return pkg.version;
    }
  }
};
</script>

<style scoped>
.popup-help__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  text-align: justify;
  justify-items: center;
  align-items: center;
  padding: 0 0.5em;
  overflow-y: auto;
}
</style>
